import config from '../config';

function createImageUri(id) { 
  return `${config.ENDPOINT}/static/place/${id}_cl.jpeg`;
}

const PLACE_NAMES = [
  { name: 'Lukla', id: 'd4a3d8f0f735', region: 'everest' },
  { name: 'Phakding', id: 'd70fb00afee1', region: 'everest' },
  { name: 'Namche Bazaar', id: 'd840302e4958', region: 'everest' },
  { name: 'Dingboche', id: 'd5d9b3e98fb3', region: 'everest' },
  { name: 'Pheriche', id: 'd29ec33ddd56', region: 'everest' },
  { name: 'Deboche', id: 'd4d9dfd8f89c', region: 'everest' },
  { name: 'Lobuche', id: 'd583bb275c08', region: 'everest' },
  { name: 'Gorakshep', id: 'd8bc4410646f', region: 'everest' },
  { name: 'Jomsom', id: 'd58f90c6c0f0', region: 'annapurna' },
  { name: 'Kagbeni', id: 'd76bb18856a7', region: 'annapurna' },
  { name: 'Muktinath', id: 'd9d5b3310c62', region: 'annapurna' },
  { name: 'Dhampus', id: 'd881a6fa7a85', region: 'annapurna' },
  { name: 'Ghandruk', id: 'd8cd710dbdab', region: 'annapurna' },
  { name: 'Chhomrong', id: 'd04858eca866', region: 'annapurna' },
  { name: 'Ghorepani', id: 'd85c644cc9be', region: 'annapurna' },
];

const addImages = () => PLACE_NAMES.map(p => ({ ...p, image: createImageUri(p.id) }));
const placeNames = addImages();

export default placeNames;


// WEBPACK FOOTER //
// ./src/constants/places.js